import type { MetaFunction } from "@remix-run/node";

import type { loader } from "./loader";

const meta: MetaFunction<typeof loader> = ({ data }) => {
  const url = data?.url;

  if (!data) return [];

  return [
    { title: `${data?.brandName} ${data?.name} | Emerson Ecologics` },
    {
      name: "title",
      content: `${data?.brandName} ${data?.name}`,
    },
    {
      name: "description",
      content: `${data?.emersonDescription?.slice(0, 157)}...`,
    },
    {
      property: "og:title",
      content: `${data?.brandName} ${data?.name}`,
    },
    {
      property: "og:description",
      content: `${data?.emersonDescription?.slice(0, 157)}...`,
    },
    { property: "og:site_name", content: "EmersonEcologics" },
    {
      property: "og:image:type",
      content: "image/png",
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "628",
    },
    {
      property: "og.type",
      content: "website",
    },
    {
      property: "og:image",
      content: `${data?.image}`,
    },
    {
      property: "og:image:alt",
      content: `${data?.brandName} ${data?.name}`,
    },
    {
      property: "og:url",
      content: `${url}`,
    },
    {
      name: "twitter:site",
      content: "@EmersonEcologic",
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: `${data?.brandName} ${data?.name}`,
    },
    {
      name: "twitter:description",
      content: `${data?.emersonDescription?.slice(0, 157)}...`,
    },
    {
      name: "twitter:image",
      content: `${data?.image}`,
    },
  ];
};

export { meta };
